import axios from "axios";

export const AddUtilsData = (startDate, endDate, packageId, full_report,offer_id) => {
  const url = process.env.REACT_APP_UTILS_API + "/util";
  return axios
    .post(
      url,
      {
        start_date: startDate,
        end_date: endDate,
        package_id: packageId,
        full_report: full_report,
        offer_id:offer_id,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          // "X-Request-ID": "124",
          // "X-Country-Code": "BD",
          // "X-Client-Name": "WEBSITE",
          // "X-Clien  t-Version": "123",
          "API-Key": "powered_by_pasiya",
        },
      }
    )
    .then((res) => {
      return res;
    });
};
export const AddConsultationsData = (
  consultationsStartDate,
  consultationsEndDatee,
  consultationsPackageId
) => {
  const url = process.env.REACT_APP_UTILS_API + "/consultations";
  return axios
    .post(
      url,
      {
        start_date: consultationsStartDate,
        end_date: consultationsEndDatee,
        package_id: consultationsPackageId,
      },
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          "API-Key": "powered_by_pasiya",
        },
      }
    )
    .then((res) => {
      return res;
    });
};
export const getAllUtilData = (page = 1) => {
  return axios
    .get(`${process.env.REACT_APP_UTILS_API}/util_all?page=${page}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        "API-Key": "powered_by_pasiya",
      },
    })
    .then((res) => res.data);
};

export const getAllConsultationData = (page = 1) => {
  return axios
    .get(process.env.REACT_APP_UTILS_API + `/consult_util_all?page=${page}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        "API-Key": "powered_by_pasiya",
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const utilImageUpload = (formData) => {
  const url = process.env.REACT_APP_UTILS_API + "/uploadcsv";
  return axios
    .post(url, formData, {
      headers: {
        "Content-Type": "form-data",
        "API-Key": "powered_by_pasiya",
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => err);
};
export const getAllCustomUtilData = () => {
  return axios
    .get(`${process.env.REACT_APP_UTILS_API}/custom_util_all`, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        "API-Key": "powered_by_pasiya",
      },
    })
    .then((res) => res.data);
};
export const getAllPackageDetails = () => {
  return axios
    .get(process.env.REACT_APP_UTILS_API + "/packages", {
      headers: {
        "Content-Type": "form-data",
        "API-Key": "powered_by_pasiya",
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const searchPackages = (name) => {
  return axios
    .get(`${process.env.REACT_APP_UTILS_API}/util_search?keyword=${name}`, {
      headers: {
        "API-Key": "powered_by_pasiya",
      },
    })
    .then((res) => res.data);
};


